<div fxLayout="row">
  <mat-icon
    fxFlex="0 0 48px"
    class="md-24 color-grey-300 u-display-block u-textAlign-center"
    >location_on</mat-icon
  >
  <div fxFlex="0 0 calc(100% - 48px)" class="text-body-2">
    <b>
      <span i18n="@@eventsView.feedItem.meetingMethod"
        >{ READABLE_MEETING_METHODS[opportunity.meeting_method], select, other
        {{{ READABLE_MEETING_METHODS[opportunity.meeting_method] }}} }</span
      >
      <span
        *ngIf="eventLocation === opportunity.location"
        i18n="@@eventsView.feedItem.meetingMethod.joinInfo"
        >. Joining info will be provided to confirmed attendees.</span
      >
    </b>
    <div class="color-grey-300">
      <p
        class="u-whiteSpace-preLine u-wordWrap-breakWord"
        [innerHTML]="
          location || '—'
            | linkify: { className: 'u-textDecoration-underline color-blue' }
        "
      ></p>
      <ng-container>
        <p
          *ngIf="opportunity.event_location?.address2 && showSecondaryLocation"
          [innerHTML]="
            opportunity.event_location.address2
              | linkify: { className: 'u-textDecoration-underline color-blue' }
          "
        ></p>
      </ng-container>
    </div>
    <ng-container
      *ngIf="
        'in-person' === READABLE_MEETING_METHODS[opportunity.meeting_method]
      "
    >
      <a
        [href]="locationMapUrl"
        target="_blank"
        class="color-blue u-textDecoration-underline--hover u-wordWrap-breakWord"
        aria-label="View Map"
      >
        <b i18n="@@eventsView.feedItem.meetingMethod.viewLocationLabel"
          >View Map</b
        >
      </a>
    </ng-container>
  </div>
</div>
